import React from 'react';
import {
  SubmitCredentialsBaseProps,
  SubmitCredentialsForm,
  SubmitCredentialsHeader,
  SubmitCredentialsScreen,
  SubmitCredentialsScreenProps,
} from '../../types';
import { HeaderProps } from '../../../../../organisms/Header/Header';

export type SubmitCredentialsScreenCreatorProps = {
  SubmitCredentialsBase: React.ComponentType<SubmitCredentialsBaseProps>;
  getHeader: (
    onBack: SubmitCredentialsScreenProps['onBack'],
    Header?: React.ComponentType<HeaderProps>
  ) => SubmitCredentialsHeader;
  getForm: (onSubmit: SubmitCredentialsScreenProps['onSubmit']) => SubmitCredentialsForm;
};

export type SubmitCredentialsScreenCreator = (
  props: SubmitCredentialsScreenCreatorProps
) => SubmitCredentialsScreen;

export const createSubmitCredentialsScreen: SubmitCredentialsScreenCreator =
  ({ SubmitCredentialsBase, getForm, getHeader }) =>
  ({ onSubmit, onBack }) => {
    const Header = getHeader(onBack);
    const Form = getForm(onSubmit);

    return <SubmitCredentialsBase Header={Header} Form={Form} />;
  };
